import { Notify } from 'quasar';

export function notifyInfo(infoMessage: string | null = null) {
  if (infoMessage) {
    Notify.create({
      color: 'primary',
      textColor: 'white',
      message: infoMessage,
    });
  }
}
